<div class="container" *ngIf="showOnSelfHelp==true">
<div class="search-block">
  <div class="container">
    <div>
      <div id="home_nav" class="row">
        <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
          <ol class="breadcrumb loginMenu">
            <li class="breadcrumb-item" style="align-items: center;float:right;">
              <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation()">Home</a>
            </li>
            <li class="breadcrumb-item active">Tracker</li>
          </ol>
        </div>
        <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
          <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
            [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
            (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
            (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()" aria-label="Type here to Search an Article"
            placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
          </ng-autocomplete>
          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.name"></a>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound>
            No Suggestion...
          </ng-template>
          <span class="input-group-append" (click)="search(searchKey)">
            <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-create-ticket *ngIf="checkCaseModalInHelpCenter" (checkIsCaseModalOpenInHelpCenter)="checkIsCaseModalOpen($event)">
</app-create-ticket>
<header class="helpCenterHeader">
  <nav class="navbar navbar-expand-lg navbar-dark pink scrolling-navbar" role="navigation">
    <a class="navbar-brand">
    </a>
    <div class="container" style="padding: 0px;">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav nav-pills">
          <ng-container *ngIf="myHelpCenterConfigurationOptionLabel">
            <li class="nav-item" *ngFor="let helpCenterConfig of myHelpCenterConfigurationOptionLabel?.slice(0,1);let i = index">
              <button class="btn" *ngIf="!helpCenterConfig.labelEnabler">
                <a class="nav-link active" style="cursor: pointer;"
                  (click)="navigationLink(i)">{{helpCenterConfig.labelText}}</a> </button>
            </li>
          </ng-container>
          <li class="nav-item">
            <button class="btn">
              <a class="nav-link active" style="cursor: pointer;" (click)='handleTrackerNavigation()'>Tracker</a> 
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
<br>
<button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == false" type="button" (click)="openChat()"  class="btn btn-primary">LIVE CHAT</button>
<button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == true" type="button"  class="btn btn-primary">LIVE CHAT</button>

<div class="container">
  <div class="accordion" id="accordionExample">
    <div class="card">
      <div *ngFor="let holder of holders?.slice(0,1)">
        <div *ngFor="let config of trackerConfigurations?.slice(0,1)">
          <div class="card-header" *ngIf="( config.tracker_type=='FA' || config.tracker_type=='SA' || (config.tracker_type=='AR' || config.tracker_type=='ARR') )
            && this.showTrackerFA && holder.trackerType!='' && config.tracker_type!=''">
            <h4 class="mb-0">
              <button class="btn btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" (click)="collapsedFA = !collapsedFA"
                aria-expanded="false" aria-controls="collapseOne" *ngFor="let trName of phaseDetails?.slice(0,1)">
                <img [src]="collapsedFA ? 'shp/assets/images/minus.png' : 'shp/assets/images/plus.png'" style="display: block;float: left;height: 15px;margin: 5px 13px 0 0;width: 15px;" alt="">
                {{trName.trackerName}}
              </button>
            </h4>
          </div>
          <div id="collapseOne" class="collapse" aria-labelledby="headingOne">
            <div class="card-body">
              <div class="card">
                <div *ngFor="let tkrvar of holder.trackers?.slice(0,1)">
                  <div class="card-header">
                    <button class="btn btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" (click)="collapsedFA1 = !collapsedFA1"
                      aria-expanded="false" aria-controls="collapse1"  (click)="viewArticleFa1(tkrvar.externalArticleId)">
                      <img [src]="collapsedFA1 ? 'shp/assets/images/minus.png' : 'shp/assets/images/plus.png'" style="display: block;float: left;height: 15px;margin: 5px 13px 0 0;width: 15px;" alt="">
                      {{tkrvar.yearLabel}}
                    </button>
                  </div>
                  <div id="collapse1" class="collapse" aria-labelledby="heading1">
                    <div class="card-body">
                      <p><b>{{tkrvar.phaseName}} {{tkrvar.stageName}}:</b></p>
                      <section>
                        <nav>
                          <ol class="tracker triangle triangle-twolines d-flex">
                            <li [ngClass]="{'finished':tkrvar.phase > 1, 'current':tkrvar.phase == 1}" *ngFor="let ph of this.faPhases?.slice(0,1)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 2, 'current':tkrvar.phase == 2}" *ngFor="let ph of this.faPhases?.slice(1,2)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 3, 'current':tkrvar.phase == 3}" *ngFor="let ph of this.faPhases?.slice(2,3)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 4, 'current':tkrvar.phase == 4}" *ngFor="let ph of this.faPhases?.slice(3,4)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'current':tkrvar.phase == 5}" *ngFor="let ph of this.faPhases?.slice(4,5)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                          </ol>
                        </nav>
                      </section>
                      <div>
                        <b>External Article:</b>
                        <div [innerHtml]="selectedValueFA1"></div>
                        <a *ngIf="selectedValueFA1 && this.showFa1 == false" class="findMore"  href="javascript:void(0);" (click)="toggleFindMoreFA1()">Find Out More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div *ngFor="let tkrvar of holder.trackers?.slice(1,2)">
                  <div class="card-header" *ngIf="this.disableFutureYearOnShp == false">
                    <button class="btn btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" (click)="collapsedFA2 = !collapsedFA2"
                      aria-expanded="false" aria-controls="collapse2"  (click)="viewArticleFa2(tkrvar.externalArticleId)">
                      <img [src]="collapsedFA2 ? 'shp/assets/images/minus.png' : 'shp/assets/images/plus.png'" style="display: block;float: left;height: 15px;margin: 5px 13px 0 0;width: 15px;" alt="">
                      {{tkrvar.yearLabel}}
                    </button>
                  </div>
                  <div id="collapse2" class="collapse" aria-labelledby="heading2">
                    <div class="card-body">
                      <p><b>{{tkrvar.phaseName}} {{tkrvar.stageName}}:</b></p>
                      <section>
                        <nav>
                          <ol class="tracker triangle triangle-twolines d-flex">
                            <li [ngClass]="{'finished':tkrvar.phase > 1, 'current':tkrvar.phase == 1}" *ngFor="let ph of this.faPhases?.slice(0,1)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 2, 'current':tkrvar.phase == 2}" *ngFor="let ph of this.faPhases?.slice(1,2)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 3, 'current':tkrvar.phase == 3}" *ngFor="let ph of this.faPhases?.slice(2,3)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'finished':tkrvar.phase > 4, 'current':tkrvar.phase == 4}" *ngFor="let ph of this.faPhases?.slice(3,4)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                            <li [ngClass]="{'current':tkrvar.phase == 5}" *ngFor="let ph of this.faPhases?.slice(4,5)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                          </ol>
                        </nav>
                      </section>
                      <div>
                        <b>External Article:</b>
                        <div [innerHtml]="selectedValueFA2"></div>
                        <a *ngIf="selectedValueFA2 && this.showFa2 == false" class="findMore"  href="javascript:void(0);" (click)="toggleFindMoreFA2()">Find Out More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div *ngFor="let holder of holders?.slice(1,2)">
        <div *ngFor="let config of trackerConfigurations?.slice(1,2)">
          <div *ngFor="let tkrvar of holder.trackers">
            <div class="card-header" *ngIf="( config.tracker_type=='FA' || config.tracker_type=='SA' || (config.tracker_type=='AR' || config.tracker_type=='ARR') )
              && this.showTrackerSA && holder.trackerType!='' && config.tracker_type!=''">
              <h4 class="mb-0">
                <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" *ngFor="let trName of phaseDetails?.slice(1,2)"
                  aria-expanded="false" aria-controls="collapseTwo" (click)="viewArticleSa(tkrvar.externalArticleId)" (click)="collapsedSA = !collapsedSA">
                  <img [src]="collapsedSA ? 'shp/assets/images/minus.png' : 'shp/assets/images/plus.png'" style="display: block;float: left;height: 15px;margin: 5px 13px 0 0;width: 15px;" alt="">
                  {{trName.trackerName}}
                </button>
              </h4>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
              <div class="card-body">
                <div>
                  <p><b class="title">{{tkrvar.phaseName}} {{tkrvar.stageName}}:</b></p>
                  <section>
                    <nav>
                      <ol class="tracker triangle triangle-twolines d-flex">
                        <li [ngClass]="{'finished':tkrvar.phase > 1, 'current':tkrvar.phase == 1}" *ngFor="let ph of this.saPhases?.slice(0,1)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                        <li [ngClass]="{'finished':tkrvar.phase > 2, 'current':tkrvar.phase == 2}" *ngFor="let ph of this.saPhases?.slice(1,2)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                        <li [ngClass]="{'finished':tkrvar.phase > 3, 'current':tkrvar.phase == 3}" *ngFor="let ph of this.saPhases?.slice(2,3)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                        <li [ngClass]="{'finished':tkrvar.phase > 4, 'current':tkrvar.phase == 4}" *ngFor="let ph of this.saPhases?.slice(3,4)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                        <li [ngClass]="{'current':tkrvar.phase == 5}" *ngFor="let ph of this.saPhases?.slice(4,5)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                      </ol>
                    </nav>
                  </section>
                </div>               
                <div>
                  <b class="title">External Article:</b>
                  <div [innerHTML]="selectedValueSA"></div>
                  <a *ngIf="selectedValueSA && this.showSa == false" class="findMore"  href="javascript:void(0);" (click)="toggleFindMoreSA()">Find Out More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div *ngFor="let holder of holders?.slice(2,3)">
        <div *ngFor="let config of trackerConfigurations?.slice(2,3)">
          <div *ngFor="let tkrvar of holder.trackers">
            <div class="card-header" *ngIf="( config.tracker_type=='FA' || config.tracker_type=='SA' || (config.tracker_type=='AR' || config.tracker_type=='ARR') )
              && this.showTrackerAR && holder.trackerType!='' && config.tracker_type!=''">
              <h4 class="mb-0">
                <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" *ngFor="let trName of phaseDetails?.slice(2,3)"
                  aria-expanded="false" aria-controls="collapseThree" (click)="viewArticleAr(tkrvar.externalArticleId)" (click)="collapsedAR = !collapsedAR">
                  <img [src]="collapsedAR ? 'shp/assets/images/minus.png' : 'shp/assets/images/plus.png'" style="display: block;float: left;height: 15px;margin: 5px 13px 0 0;width: 15px;" alt="">
                  {{trName.trackerName}}
                </button>
              </h4>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
              <div class="card-body">
                <p><b class="title">{{tkrvar.phaseName}} {{tkrvar.stageName}}:</b></p>
                <section>
                  <nav>
                    <ol class="tracker triangle triangle-twolines d-flex">
                      <li [ngClass]="{'finished':tkrvar.phase > 1, 'current':tkrvar.phase == 1}" *ngFor="let ph of this.arPhases?.slice(0,1)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="d-inline-flex" class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                      <li [ngClass]="{'finished':tkrvar.phase > 2, 'current':tkrvar.phase == 2}" *ngFor="let ph of this.arPhases?.slice(1,2)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="d-inline-flex" class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                      <li [ngClass]="{'finished':tkrvar.phase > 3, 'current':tkrvar.phase == 3}" *ngFor="let ph of this.arPhases?.slice(2,3)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="d-inline-flex" class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                      <li [ngClass]="{'finished':tkrvar.phase > 4, 'current':tkrvar.phase == 4}" *ngFor="let ph of this.arPhases?.slice(3,4)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="d-inline-flex" class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                      <li [ngClass]="{'current':tkrvar.phase == 5}" *ngFor="let ph of this.arPhases?.slice(4,5)"><span class="d-inline-flex" style="font-size: 16px; line-height: 21px; " ><p class="d-inline-flex" class="m-auto pl-2 px-2" [innerHtml]= "ph.shpLabel"></p></span></li>
                    </ol>
                  </nav>
                </section>
                <div>
                  <b class="title">External Article:</b>
                  <div [innerHtml]="selectedValueAR"></div>
                  <a *ngIf="selectedValueAR && this.showAr == false" class="findMore"  href="javascript:void(0);" (click)="toggleFindMoreAR()">Find Out More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>